<template>
    <div>
        <GlobalMessage v-if="messageList.length"></GlobalMessage>
        <div class="layout__container"
             :style="{height: globalContentHeight}">
          <router-view v-if="$route.meta.type === 'single'"></router-view>
          <div class="layout__title flex flex--align-center flex--justify-between">
            <h1>{{parentRoute.meta.title}}</h1>
            <v-icon type="iconaccess_alarm-24px"
                    v-if="parentRoute.name === 'dashboard' && isShowControlAccountNotice"
                    @click.native="handleShowNoticeConfig"
                    right-text="余额和服务提醒"></v-icon>
          </div>
          <div class="layout__body flex">
            <LayoutSubMenu v-if="parentRoute.children"></LayoutSubMenu>
            <div class="layout__content">
              <router-view></router-view>
            </div>
          </div>
          <MessageList></MessageList>
          <NoticeConfig></NoticeConfig>
          <Recharge></Recharge>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import mainRouterList from '@/router/mainRouterList';
import GlobalMessage from '@/components/b-components/globalMessage/globalMessage.vue';
import MessageList from '@/components/b-components/messageList/messageList.vue';
import NoticeConfig from '@/components/b-components/noticeConfig/noticeConfig.vue';
import Recharge from '@/components/b-components/recharge/recharge.vue';
import LayoutSubMenu from './layoutSubMenu.vue';

export default {
  name: 'dashboard',
  components: {
    LayoutSubMenu,
    GlobalMessage,
    MessageList,
    NoticeConfig,
    Recharge,
  },
  computed: {
    ...mapState('user', ['btnList']),
    ...mapState('message', {
      messageList: 'messageOnDashboard'
    }),
    parentRoute() {
      const parentName = this.$route.name.split('-')[0];
      return mainRouterList[0].children.find((r) => r.name === parentName);
    },
    globalContentHeight() {
      return `calc(100vh - ${(this.messageList.length ? 194 : 96)}px)`;
    },
    isShowControlAccountNotice() {
      return this.btnList.includes('control_account_notice');
    },
  },
  methods: {
    ...mapMutations(['updateState']),
    handleShowNoticeConfig() {
      this.updateState({
        noticeVisible: true,
      });
    },
  },
};
</script>
<style lang="less">

</style>